<template>
  <div class="qa-page-container">
    <!-- 设备卡片 -->
    <devicecard host="QA"></devicecard>
    
    <!-- 搜索区域 -->
    <div class="search-section">
      <van-search
        v-model="searchvalue"
        placeholder="请输入型号关键词"
        shape="round"
        show-action
        @search="onSearch"
        @cancel="onCancel"
        class="search-box"
      >
        <template #action>
          <div @click="onSearch" class="search-action">搜索</div>
        </template>
      </van-search>
    </div>

    <!-- 问答列表 -->
    <div class="qa-content">
      <QAList 
        host="QA" 
        :models="qakeyword" 
        :sn="qasn" 
        v-if="renderComponent" 
        :key="componentKey"
      ></QAList>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import devicecard from '../../components/devicecard.vue';
import QAList from '../../components/qalist.vue';

export default {
  name: 'QAPage',
  components: {
    devicecard,
    QAList
  },
  data() {
    return {
      searchvalue: '',
      qakeyword: '',
      qasn: '',
      renderComponent: true,
      componentKey: 0
    }
  },
  methods: {
    onSearch() {
      console.log(this.searchvalue, 'searchvalue')
      this.qakeyword = this.searchvalue
      this.forceRerender()
    },
    
    forceRerender() {
      // 使用更好的重新渲染方式
      this.componentKey += 1
    },
    
    onCancel() {
      this.searchvalue = ''
      this.qakeyword = ''
      this.forceRerender()
    }
  }
}
</script>

<style scoped>
.qa-page-container {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 20px;
}

.search-section {
  background-color: #ffffff;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.search-box {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
}

.search-action {
  color: #1989fa;
  font-size: 14px;
  padding: 0 8px;
}

.qa-content {
  padding: 16px;
}

/* 响应式设计 */
@media (max-width: 360px) {
  .search-section {
    padding: 12px;
  }
  
  .qa-content {
    padding: 12px;
  }
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
}

/* 空状态样式 */
.empty-search {
  text-align: center;
  padding: 60px 20px;
  color: #969799;
}

.empty-search .search-tips {
  margin-top: 16px;
  font-size: 14px;
}

/* 搜索提示 */
.search-tips {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 6px;
  padding: 12px;
  margin: 16px;
  text-align: center;
  font-size: 13px;
  color: #1890ff;
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
  .search-action:hover {
    opacity: 0.8;
  }
}
</style>